import { useSuspenseQuery } from '@apollo/client';
import { UpdateVisibleUnitsForm } from '@features/preferencesCommon';
import { type FC } from 'react';
import GET_USER_PREFERENCES_VISIBLE_UNITS from '../graphql/queries/getUserPreferencesVisibleUnits';
import { TabProps } from '../types';

export const VisibleUnitsTab: FC<TabProps> = ({ userId }) => {
  const { data } = useSuspenseQuery(GET_USER_PREFERENCES_VISIBLE_UNITS, {
    variables: {
      input:
        userId != null
          ? {
              id: userId,
            }
          : null,
    },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <UpdateVisibleUnitsForm
      entity={{
        type: 'user',
        id: userId,
      }}
      data={data.user.preferences.visibleUnits}
      factoryDefaults={data.user.preferences.defaultValues}
    />
  );
};
